import React from 'react'
import type { ReactNode } from 'react';

import { styled } from '@mui/material'
import classNames from 'classnames'

import type { Variant } from '../../utils/constants';
import { HELPER_TYPE_ERROR, HELPER_TYPE_SUCCESS } from '../../utils/constants'
import testHandle from '../../utils/testHandle'

const StyledError = styled('span')<{ variant?: Variant; labelWidth?: string | null | undefined }>(
  ({ theme, variant, labelWidth }) => `
  display: block;
  color: ${theme.colours.danger};
  margin-top: 0.1rem;
  display: block;
  margin-bottom: 0;
  font-size: 12px;

  margin-left: ${variant === 'compact' ? 'calc(33% + 4px)' : variant === 'compactLeftAligned' ? `calc(${labelWidth ? labelWidth : '30%'})` : 0};

  &.error {
    color: ${theme.colours.danger};
    a,
    a:hover {
      color: ${theme.colours.danger};
    }
  }

  &.success {
    color: ${theme.colours.successColor};
  }
`,
)

export type HelperTextProps = {
  message: ReactNode
  textType?: string
  variant?: Variant
  id?: string
  labelWidth?: string | null 
}

const HelperText = ({ id, message, variant = 'default', textType, labelWidth }: HelperTextProps) => {
  const dataTestId = id ? testHandle(id) : id
  const className = classNames({
    error: textType === HELPER_TYPE_ERROR,
    success: textType === HELPER_TYPE_SUCCESS,
  })

  return (
    <StyledError className={className} data-testid={`${dataTestId}-error`} variant={variant} labelWidth={labelWidth}>
      {message}
    </StyledError>
  )
}

export default HelperText
